import type { FC } from 'react';
import { FormField } from '../FormField/FormField';
import { TextAreaInput } from '../TextAreaInput/TextAreaInput';
import type { TextAreaFieldProps } from './TextAreaField.types';

export const TextAreaField: FC<TextAreaFieldProps> = ({
  className,
  error,
  value = '',
  ...props
}) => {
  return (
    <FormField className={className} error={error} {...props}>
      <TextAreaInput
        {...props}
        value={value}
        hasError={props.hasError || error !== undefined}
      />
    </FormField>
  );
};
